export const setItem = (
  key: string,
  value: string,
  useLocalStorage: boolean
) => {
  if (useLocalStorage) {
    localStorage.setItem(key, value);
  } else {
    sessionStorage.setItem(key, value);
  }
};

export const getItem = (key: string) => {
  if (getUseLocalStorage()) {
    return localStorage.getItem(key);
  }
  return sessionStorage.getItem(key);
};

export const removeItem = (key: string) => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

export const getUseLocalStorage = () => {
  const storedValue = localStorage.getItem('useLocalStorage');
  let retrievedBoolean: boolean | null = null;
  if (storedValue !== null) {
    retrievedBoolean = JSON.parse(storedValue);
    return retrievedBoolean || false;
  }
  return false;
};
